import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { SettingsService } from "@features/settings/services/settings.service";
import { CommandEvent, commandEvent } from "@shared/components/load/command/command.component";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { ProviderSetting } from "../../../models/provider-settings";

@Component({
  selector: 'app-provider-settings-edit',
  templateUrl: './provider-settings-edit.component.html'
})
export class ProviderSettingsEditComponent {
  private providers: ProviderSetting[] = [];
  @Input() saved: () => void = () => { };
  @Input() cancel: () => void = () => { };

  form = new UntypedFormGroup({});
  
  load$ = this.settingsService.getProviders().pipe(tap(providers => {
    this.providers = providers;
    providers.forEach(p => this.form.addControl(p.id, new UntypedFormControl(p.selected)));
  }));
  private change$: Subject<ProviderSetting[]> = new Subject<ProviderSetting[]>();
  update$: Observable<CommandEvent<ProviderSetting[]>> = commandEvent(
    this.change$,
    x => this.settingsService.updateProviders(x));

  constructor(private settingsService: SettingsService) {}

  toggleSelection(index: number): void {
    this.providers[index].selected = !this.providers[index].selected;
  }

  save() {
    this.change$.next(this.providers);
  }
}